import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "h-width-100p" }
const _hoisted_2 = { class: "multiselect__item-header h-flex h-flex-dir-column h-max-width-100p" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "b-select-address--no-result" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "h-mt-20 h-fw-500 h-font-14 h-opacity-0_5" }
const _hoisted_7 = {
  key: 3,
  class: "h-flex h-flex-space-between h-mb-20 h-mt-20"
}
const _hoisted_8 = { key: 4 }
const _hoisted_9 = {
  key: 0,
  ref: "map",
  style: {"opacity":"0","position":"fixed","left":"-100%"},
  class: "b-branch-office-map-size"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_FwSelect = _resolveComponent("FwSelect")!
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_GlobalMap = _resolveComponent("GlobalMap")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.placeLoading)
      ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
          key: 0,
          colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
          class: "h-flex-center loader",
          isActive: _ctx.loading,
          className: "h-p-20"
        }, null, 8, ["isActive"]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_FwSelect, {
      ref: "autocomplete",
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      class: _normalizeClass(["fw-select-address__absolute b-select-address", {
            // "b-select-address--with-start-address": startAddress && !value,
            "b-select-address--with-value": _ctx.value,
            "b-select-address--loading": _ctx.loading,
        }]),
      multiple: false,
      label: "text",
      "clear-on-select": false,
      propsPlaceholder: _ctx.text,
      searchable: true,
      allowEmpty: true,
      searchIcon: true,
      closeOnSelect: true,
      noElementsFoundText: "",
      disabled: _ctx.isDisabled,
      internalSearch: false,
      existedValue: !!_ctx.startAddress,
      openDirection: "bottom",
      options: _ctx.options,
      onSearchChange: _ctx.searchChange,
      onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideMap = true)),
      onSelect: _ctx.getPlace,
      onRemoveValue: _ctx.removeValue
    }, {
      option: _withCtx(({ props }) => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
              key: 0,
              colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
              class: "h-flex-center loader",
              isActive: _ctx.loading,
              className: "h-p-20"
            }, null, 8, ["isActive"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "option", { props: props }, () => [
          _createElementVNode("div", {
            style: _normalizeStyle({ opacity: _ctx.loading ? 0 : 1 }),
            class: "multiselect__content-item"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(props.option.city) + " " + _toDisplayString(props.option.country), 1)
            ])
          ], 4)
        ])
      ]),
      noResult: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createElementVNode("span", null, null, -1)
      ]))]),
      noOptions: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createElementVNode("span", null, null, -1)
      ]))]),
      _: 3
    }, 8, ["modelValue", "class", "propsPlaceholder", "disabled", "existedValue", "options", "onSearchChange", "onSelect", "onRemoveValue"])), [
      [_directive_focus, _ctx.autofocus]
    ]),
    (!_ctx.isSearchQueryShort && !_ctx.options.length && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('SELECTOR.NO.ELEMENT.FOUND')), 1)
        ]))
      : (_ctx.options.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('EVENT.NAME.LOCATION.RESULT')) + ": ", 1)
          ]))
        : _createCommentVNode("", true),
    (_ctx.postCodeCannotDetect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_FwFormInput, {
            class: "h-flex-1-0",
            labelType: "label-medium",
            title: `${_ctx.$t(`LABEL.ZIP.CODE`)}*`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FwInput, {
                value: _ctx.post_code,
                type: "number",
                name: "text",
                placeholder: _ctx.$t(`LABEL.ZIP.CODE`),
                inputStyle: "white-bigger",
                onInput: _cache[2] || (_cache[2] = value => _ctx.changePostCodeValue(value))
              }, null, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideMap)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.mapsApi_isGoogleMap)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, null, 512))
            : _createCommentVNode("", true),
          (_ctx.coords)
            ? (_openBlock(), _createBlock(_component_GlobalMap, {
                key: 1,
                latitude: _ctx.coords.latitude,
                longitude: _ctx.coords.longitude
              }, null, 8, ["latitude", "longitude"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}